import React from "react";

import Skeleton from "@mui/material/Skeleton";

const TableSkeleton = () => {
	return <Skeleton variant="rectangular" height={600} />;
};

export default TableSkeleton;
